import { render, staticRenderFns } from "./WDG-order-pay.vue?vue&type=template&id=dd9e05d8"
import script from "./WDG-order-pay.vue?vue&type=script&lang=js"
export * from "./WDG-order-pay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports